import type { InvoiceSummary, PublicPlanPrice, UpcomingInvoice } from '@/types/billing';

export const DEFAULT_BILLING_CURRENCY = 'RUB';

function normalizeCurrency(value?: string | null): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const normalized = value.trim().toUpperCase();
  return normalized.length ? normalized : null;
}

export function resolveBillingCurrency(options: {
  upcomingInvoice?: UpcomingInvoice | null;
  invoices?: InvoiceSummary[];
  publicPlanPrices?: Record<'basic' | 'pro', PublicPlanPrice> | null;
  currentPaidPlan?: 'basic' | 'pro' | null;
}): string {
  const upcomingCurrency = normalizeCurrency(options.upcomingInvoice?.currency);
  if (upcomingCurrency) {
    return upcomingCurrency;
  }

  const invoiceCurrency = options.invoices
    ?.map((invoice) => normalizeCurrency(invoice.currency))
    .find((currency): currency is string => currency !== null);
  if (invoiceCurrency) {
    return invoiceCurrency;
  }

  const publicPlanCurrency = options.currentPaidPlan
    ? normalizeCurrency(options.publicPlanPrices?.[options.currentPaidPlan]?.currency)
    : null;
  if (publicPlanCurrency) {
    return publicPlanCurrency;
  }

  return DEFAULT_BILLING_CURRENCY;
}
